<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconTrash_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M15 6H3a1 1 0 0 1 0-2h6V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1h6a1 1 0 1 1 0 2h-6Zm5 2H4v13a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Zm-9 4a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0v-7Zm3-1a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1Z"
        clip-rule="evenodd"
    />
</svg>
